export default __webpack_public_path__ + "static/media/banner-22-AR.2c7e05b5.png";